__turbopack_context__.v({
  "container": "oUz8yG_container",
  "content": "oUz8yG_content",
  "icon": "oUz8yG_icon",
  "isFullscreen": "oUz8yG_isFullscreen",
  "spin": "oUz8yG_spin",
  "text": "oUz8yG_text",
});
